module.exports = __webpack_public_path__ + "img/share3.bb594269.png";